import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

class MarqueeSlider {
  constructor() {
    this.containers = document.querySelectorAll('.js-marquee-slider');
  }

  init() {
    if (!this.containers.length) return;

    const PIXELS_PER_SECOND = 40;
    
    function applySpeed(s) {
        let total = 0;

        s.slides.forEach((slide) => {
            total += slide.offsetWidth;
        });

        const avg = total / s.slides.length || 200;
        const pps = parseInt(s.el.dataset.speed, 10) || PIXELS_PER_SECOND;

        s.params.speed = Math.round((avg / pps) * 1000);
    }

    this.containers.forEach((el) => {
      const reverse = el.dataset.direction === 'rtl';

      const swiper = new Swiper(el, {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        loopAdditionalSlides: 5,
        allowTouchMove: false,
        speed: 7000,
        freeMode: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            reverseDirection: reverse,
        },
        on: {
            init(s) {
                applySpeed(s);
            },
            slideChangeTransitionEnd(s) {
              if (!s.autoplay.running) s.autoplay.start();
            },
        },
      });

      const recalc = () => {
        swiper.update();
        applySpeed(swiper);
      };

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(recalc);
      }

      if (document.readyState !== 'complete') {
        window.addEventListener('load', recalc, { once: true });
      }

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) swiper.autoplay.start();
      });
      
      window.addEventListener('resize', () => {
        swiper.update();
        applySpeed(swiper);
      }, { passive: true });
    });
  }
}

export default new MarqueeSlider();